import TravelIllustration from 'svg/illustrations/Travel';
import TeamWorkingIllustration from 'svg/illustrations/TeamWorking';
import RocketIllustration from 'svg/illustrations/Rocket';
import CloudHostingIllustration from 'svg/illustrations/CloudHosting';
import CityIllustration from 'svg/illustrations/City';

const productsData = [
  {
    id: 'streaming',
    title: 'Streaming 24/7',
    product: 'Rotación diaria en streaming',
    investment: 'Incluido en plan mensual',
    image: RocketIllustration,
    imageAlt: 'Ilustración de streaming',
    impacts: [
      '12 spots diarios de 20 segundos en la señal de TNO Network.',
      'Recordación de marca permanente en audiencia activa.',
      'Frecuencia alta para reforzar posicionamiento de hospitalidad premium.',
    ],
  },
  {
    id: 'punto-de-fe',
    title: 'Integración en Punto de Fe',
    product: 'Menciones orgánicas con Margarita',
    investment: 'Incluido en plan mensual',
    subtitle: '3 menciones semanales',
    image: TeamWorkingIllustration,
    imageAlt: 'Ilustración de Punto de Fe',
    impacts: [
      'Posicionamiento del hotel como refugio de paz y bienestar.',
      'Conexión con una audiencia de estilo de vida consciente.',
      'Confianza por recomendación editorial de autora.',
    ],
  },
  {
    id: 'digest',
    title: 'TNO Digest (SEO y Autoridad)',
    product: 'Periodismo experto en SEO',
    investment: 'Incluido en plan mensual',
    image: '/images/digest-illustration.png',
    imageAlt: 'Ilustración para TNO Digest',
    impacts: [
      '2 reseñas especializadas al mes escritas por periodistas SEO.',
      '1 artículo comparativo o de estilo de vida con enlaces directos a reservas.',
      'Mejor posicionamiento orgánico para hospedaje premium en Caracas.',
      'Estrategia de afiliados con enlaces rastreables para conversión.',
    ],
  },
  {
    id: 'ondemand',
    title: 'On-Demand Tipo Tour',
    product: 'Cápsulas visuales a la carta',
    investment: 'Incluido en plan mensual',
    image: TravelIllustration,
    imageAlt: 'Ilustración en SVG',
    impacts: [
      'Contenido visual del hotel disponible para consumo bajo demanda.',
      'Activos reutilizables para comercial, redes y seguimiento de ventas.',
      'Extiende la vida útil de la campaña más allá del vivo.',
    ],
  },
  {
    id: 'banner',
    title: 'Presencia Web',
    product: 'Banner de aliado en portal principal',
    investment: 'Incluido en plan mensual',
    image: CloudHostingIllustration,
    imageAlt: 'Ilustración de presencia web',
    impacts: [
      'Visibilidad continua en el portal de TNO Network.',
      'Derivación de tráfico cualificado hacia reserva o página del hotel.',
      'Refuerzo de autoridad de marca en entorno editorial.',
    ],
  },
  {
    id: 'redes-ugc',
    title: 'Redes Sociales y UGC',
    product: 'Colaboraciones y publicidad tipo UGC',
    investment: 'Incluido en plan mensual',
    image: CityIllustration,
    imageAlt: 'Ilustración de redes y UGC',
    impacts: [
      'Piezas tipo UGC para redes inspiradas en experiencias del hotel.',
      'Colaboraciones con autores y comunidades del ecosistema TNO.',
      'Difusión multiplataforma para aumentar alcance y engagement.',
      'Llamados a la acción con links rastreables para convertir en reserva.',
    ],
  },
];

export default productsData;
